export default{
    lastMessages : {
        a: {
            name : 'Chat sem mensagens',
            message : ''
        },
        b: {
            name : 'Chat sem mensagens',
            message : ''
        },
        c: {
            name : 'Chat sem mensagens',
            message : ''
        },
        geral: {
            name : 'Chat sem mensagens',
            message : ''
        },
        
    },
    newMessages : 0,
    messages : [],
    feedback : {
        experience : '',
        preferredEvaluationModel : '',
        gift : '',
        problem: ''
    }
}